// import * as React from "react";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Box, Stack } from '@mui/system'
// import { useStyles } from "./Style";
import InputLabel from '@mui/material/InputLabel'
import 'date-fns/locale/es' // Importamos la localización en español
import 'moment/locale/es'

import './index.css'
export default function ResponsiveDatePickers({
  onChange,
  value,
  minDate,
  maxDate,
  onBlur,
  Title,
  error,
  Label,
  placeholder,
  disableFuture,
  disablePast,
  openTo = 'year',
  disableDay = true,
  datePickerHeight,
  disabledInput = false,
  ...props
}) {
  // const classes = useStyles();

  return (
    <Stack sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Box className={''}>
          <InputLabel
            shrink
            htmlFor="bootstrap-input"
          >
            {Label}
          </InputLabel>
          <DatePicker
            className={'form-control custom-picker'}
            label=""
            openTo={openTo}
            onBlur={onBlur}
            views={['year', 'month', 'day']}
            inputFormat="DD/MM/yyyy"
            onChange={onChange}
            value={value}
            disableFuture={disableFuture}
            disablePast={disablePast}
            minDate={minDate}
            maxDate={maxDate}
            sx={{
              height: '30px' || 'auto',
              '& .MuiInputBase-input': {
                height: datePickerHeight,
              },
            }}
            disabled={disabledInput}
            slotProps={{
              textField: {
                error: false,
              },
            }}
          />
        </Box>
      </LocalizationProvider>
      {error && (
        <p
          className={''}
          style={{ color: 'red', fontSize: 11.99 }}
        >
          {error}
        </p>
      )}
    </Stack>
  )
}
